import { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Badge,
  Spinner
} from "reactstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ReactHtmlParser from 'react-html-parser';
import { addEvent, getOfferEvents, deleteEvent, updateEvent } from "service/event.service";
const FormModal = ({ isOpen, toggleModal,handleFormUpdate, eventData }) => {
  const [formData, setFormData] = useState({
    event_title: "",
    event_type: "",
    event_long_description: "",
    event_tags: "",
    event_user_reward: 0,
    is_locked: false,
    is_retention_available: false,
    retention_period: 0,
    event_revenue: 0,
    event_payout: 0,
    id: 0,
    offerId: 0,
  });

  useEffect(() => {
    if (eventData) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        ...eventData,
      }));
    }
  }, [eventData]);

  


  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
    
      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction
    
      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'font': [] }],
      [{ 'align': [] }],
    
      ['clean']                                         // remove formatting button
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked,
    }));
  };
  const replaceStylesWithFontTags = (html)=> {
    var temp = document.createElement('div');
    temp.innerHTML = html;

    var elements = temp.querySelectorAll('[style]');
    elements.forEach(function (element) {
        var color = element.style.color;
        if (color) {
            var fontTag = document.createElement('font');
            fontTag.setAttribute('color', color);
            fontTag.innerHTML = element.innerHTML;
            element.parentNode.replaceChild(fontTag, element);
        }
    });

    return temp.innerHTML;
}
  const handleEditorChange = (value) => {


  
    setFormData((prevFormData) => ({
      ...prevFormData,
      event_long_description: value,
    }));

    // setFormData((prevFormData) => ({
    //   ...prevFormData,
    //   event_long_description: value,
    // }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleFormSubmit(formData);
    toggleModal();
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    handleFormUpdate(formData);
    toggleModal();
  };

  const { is_locked, is_retention_available } = formData;

  return (
    <Modal isOpen={isOpen} toggle={toggleModal} className="">
      <ModalHeader toggle={toggleModal}>Update Event: {formData.id}</ModalHeader>
      <ModalBody>
        <form >
          <FormGroup>
            <Label for="offerName">Event Title</Label>
            <Input
              type="text"
              name="event_title"
              id="offerName"
              placeholder="Title"
              value={formData.event_title}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="selectedOption">Type</Label>
            <Input
              type="text"
              name="event_type"
              id="event_type"
              value={formData.event_type}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="selectedOption">Tags</Label>
            <Input
              type="text"
              name="event_tags"
              id="selectedOption"
              value={formData.event_tags}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label for="selectedOption">User Reward Coins</Label>
            <Input
              type="number"
              name="event_user_reward"
              id="event_user_reward"
              value={formData.event_user_reward}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label for="email">Long Description</Label>
            <ReactQuill
              value={formData.event_long_description}
              onChange={handleEditorChange}
              theme="snow"
              modules={modules}
              placeholder="Write something awesome..."
            />
          </FormGroup>

    

          <fieldset className="custom-fieldset mt-3">
            <legend className="custom-legend">Miscellaneous</legend>

            <FormGroup>
              <Label>Is Locked</Label>
              <CustomInput
                type="switch"
                id={`isLocked`}
                name={is_locked}
                label="Is Locked"
                checked={formData.is_locked}
                onChange={() =>
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    is_locked: !prevFormData.is_locked,
                  }))
                }
              />
            </FormGroup>
            <FormGroup>
              <Label>Is Retention</Label>
              <CustomInput
                type="switch"
                id={`isRetention`}
                name={is_retention_available}
                label="Is Retention"
                checked={formData.is_retention_available}
                onChange={() =>
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    is_retention_available:
                      !prevFormData.is_retention_available,
                  }))
                }
              />
            </FormGroup>
            {
              formData.is_retention_available && (

              <FormGroup>
                <Label for="selectedOption">No of Day's</Label>
                <Input
                  type="number"
                  name="retention_period"
                  id="retention_period"
                  value={formData.retention_period}
                  onChange={handleChange}
                />
              </FormGroup>

              )
            }
            
          </fieldset>

         {( eventData && eventData.id ) ? (<Button type="submit" color="primary" className="mt-3" onClick={handleUpdate}>
            Update
          </Button>):(<Button type="submit" color="primary" className="mt-3" onClick={handleSubmit}>
            Submit
          </Button>)}


         
        </form>
      </ModalBody>
    </Modal>
  );
};
const FormCreateModal = ({ createModalOpen, createModalToggle, handleFormSubmit, eventData }) => {
  const [formData, setFormData] = useState({
    event_title: "",
    event_type: "",
    event_long_description: "",
    event_tags: "",
    event_user_reward: 0,
    is_locked: false,
    is_retention_available: false,
    event_revenue: 0,
    event_payout: 0,
    id: 0,
    offerId: 0,
  });

  useEffect(() => {
    if (eventData) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        ...eventData,
      }));
    }
  }, [eventData]);


  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
    
      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction
    
      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'font': [] }],
      [{ 'align': [] }],
    
      ['clean']                                         // remove formatting button
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked,
    }));
  };
  // Function to replace inline styles with <font> tags
  const replaceInlineStylesWithFontTags = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;

    const elements = temp.querySelectorAll('*');
    for (let i = 0; i < elements.length; i++) {
      const inlineStyle = elements[i].getAttribute('style');
      if (inlineStyle) {
        const fontTag = document.createElement('font');
        const styleProperties = inlineStyle.split(';');

        for (let j = 0; j < styleProperties.length; j++) {
          const property = styleProperties[j].trim();
          if (property) {
            const [key, value] = property.split(':');
            fontTag.setAttribute(key.trim(), value.trim());
          }
        }

        elements[i].parentNode.replaceChild(fontTag, elements[i]);
      }
    }

    return temp.innerHTML;
  };




  const handleEditorChange = (value) => {

    const html = replaceInlineStylesWithFontTags(value);
  

    console.log("============//html=============");
    console.log(html);
    console.log("============html//=============");
    setFormData((prevFormData) => ({
      ...prevFormData,
      event_long_description: html,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleFormSubmit(formData);
    createModalToggle();
  };

  

  const { is_locked, is_retention_available } = formData;

  return (
    <Modal isOpen={createModalOpen} toggle={createModalToggle} className="">
      <ModalHeader toggle={createModalToggle}>Add Event</ModalHeader>
      <ModalBody>
        <form >
          <FormGroup>
            <Label for="offerName">Event Title</Label>
            <Input
              type="text"
              name="event_title"
              id="offerName"
              placeholder="Title"
              value={formData.event_title}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="selectedOption">Type</Label>
            <Input
              type="text"
              name="event_type"
              id="event_type"
              value={formData.event_type}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="selectedOption">Tags</Label>
            <Input
              type="text"
              name="event_tags"
              id="selectedOption"
              value={formData.event_tags}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label for="selectedOption">User Reward Coins</Label>
            <Input
              type="number"
              name="event_user_reward"
              id="event_user_reward"
              value={formData.event_user_reward}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label for="email">Long Description</Label>
            <ReactQuill
              value={formData.event_long_description}
              onChange={handleEditorChange}
              theme="snow"
              modules={modules}
              placeholder="Write something awesome..."
            />
          </FormGroup>

    

          <fieldset className="custom-fieldset mt-3">
            <legend className="custom-legend">Miscellaneous</legend>

            <FormGroup>
              <Label>Is Locked</Label>
              <CustomInput
                type="switch"
                id={`isLocked`}
                name={is_locked}
                label="Is Locked"
                checked={formData.is_locked}
                onChange={() =>
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    is_locked: !prevFormData.is_locked,
                  }))
                }
              />
            </FormGroup>
            <FormGroup>
              <Label>Is Retention</Label>
              <CustomInput
                type="switch"
                id={`isRetention`}
                name={is_retention_available}
                label="Is Retention"
                checked={formData.is_retention_available}
                onChange={() =>
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    is_retention_available:
                      !prevFormData.is_retention_available,
                  }))
                }
              />
            </FormGroup>
          </fieldset>

        <Button type="submit" color="primary" className="mt-3" onClick={handleSubmit}>
            Submit
          </Button>


         
        </form>
      </ModalBody>
    </Modal>
  );
};

const FormCard = ({ form, handleEdit, handleDelete }) => {
  const [expanded, setExpanded] = useState(false);
  const [logDescrtion, setLogDescription] = useState("");

  const handleSeeMore = () => {
    setExpanded(true);
  };



  return (
  
    <div className="col-md-12">
    <Card className="mb-3">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-3">
          {/* First Row */}
          <div>
          <span className="ms-2 mr-2">#{form.id}</span>
            {form.is_locked && <Badge  className="bg-gradient-success ml-2 text-white" >Locked</Badge>}
            {form.is_retention_available && (
              <Badge className="bg-gradient-warning mr-2 text-white">Retention</Badge>
            )}
             {form.is_retention_available && (
              <Badge className="bg-gradient-success mr-2 text-white"> No oF Day's - { form.retention_period }</Badge>
            )}
           
          </div>
          {/* Edit and Delete Buttons */}
          <div>
            <Button color="primary" onClick={() => handleEdit(form)}>
              Edit
            </Button>{" "}
            <Button color="danger" onClick={() => handleDelete(form)}>
              Delete
            </Button>
          </div>
        </div>

        <fieldset className="custom-fieldset mt-3">
            <legend className="custom-legend">Event Description</legend>
        {/* Second Row */}

        <h5 className="card-title">{form.event_title}  &nbsp;
        <Badge className="bg-gradient-primary mr-2 text-white">{form.event_user_reward}</Badge>
        </h5>

        {/* Third Row */}
        <p className="card-text">
       {ReactHtmlParser(form.event_long_description)}
        </p>
          </fieldset>

         
      </CardBody>
    </Card>
    </div>

  );
};

const Step4Form = ({ formData, handleOfferChange, handleNextStep,handlePreviousStep }) => {
  const [forms, setForms] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [offerId, setOfferId] = useState(0);
  const [eventData, setEventData] = useState({});
  const [isPreloading, setIsPreLoaded] = useState(true);
  const [step, setStep] = useState(4);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect( () => {
    console.log(formData);
      fetchAllEvents(formData);
  }, [formData]);
  const toggleModal = () => {

    setModalOpen(!modalOpen);

  };

  const createModalToggle = () => {
    setCreateModalOpen(!createModalOpen);
  }


  const fetchAllEvents = async (formData) => {

    setOfferId(formData.id);

    const events = await getOfferEvents(formData.id);
    console.log(events);
    setForms(events.data.result);

  }

  const handleFormSubmit = async (formData) => {
    setForms((prevForms) => [...prevForms, formData]);
    formData.offerId = offerId;

    console.log("==========$$$$$==========");
    console.log(formData);
    console.log("==========$$$$$==========");

    

    const eventAdded = await addEvent(formData);
    console.log(eventAdded);
  };

  const handleFormUpdate = async (formData) => {
    console.log("==========$$$$$==========");
    console.log(formData);
    console.log("==========$$$$$==========");
    
    updateForm(formData.id, formData);
    formData.offerId = offerId;
    console.log(formData);

    const eventAdded = await updateEvent(formData.id,formData);
    console.log(eventAdded);
  };
  const updateForm = (formIdToUpdate, formData) => {
    const index = forms.findIndex(form => form.id === formIdToUpdate);
    if (index !== -1) {
      const updatedForms = [...forms];
      updatedForms[index] = formData;
      setForms(updatedForms);
    }
  };

  const handleEdit = (form) => {

    setEventData(form);
    toggleModal();
  };

  const handleDelete = async (form) => {

    const eventDeleted = await deleteEvent(form.id);

    setForms((prevForms) => prevForms.filter((prevForm) => prevForm !== form));
  };

  return (
    <><div>
      <div className="mb-3 d-flex align-items-center justify-content-between">
        <div>Create Events</div>
        {formData.id > 0 ? (
          <span className="badge badge-success badge-sm my-auto ms-auto me-3 text-dark">
            Offer Id: <strong>{formData.id}</strong>
          </span>
        ) : null}
      </div>
      <Button color="primary" className="btn btn-sm" onClick={createModalToggle}>
        {" "}
        <i className="fas fa-plus"></i> Add Event
      </Button>
      <div className="row mt-3">
        {forms.map((form, index) => (
          <FormCard key={index} form={form} handleEdit={handleEdit} handleDelete={handleDelete} />
        ))}
      </div>
      <FormModal
        isOpen={modalOpen}
        toggleModal={toggleModal}
        handleFormUpdate={handleFormUpdate}
        eventData={eventData} />
         <FormCreateModal
        createModalOpen={createModalOpen}
        createModalToggle={createModalToggle}
        handleFormSubmit={handleFormSubmit}
        eventData={{}} />
    </div><div className="d-flex justify-content-between mt-3">
        {step > 1 && (
          <Button type="button" color="secondary" onClick={handlePreviousStep}>
            Back
          </Button>
        )}

        {step === 4 && (
          <Button type="submit" color="primary" disabled={isSubmitting} onClick={handleNextStep}>
            {isSubmitting ? <Spinner size="sm" color="light" /> : "Final Submit"}
          </Button>
        )}
      </div></>
  );
};

export default Step4Form;
